import { type QuotingProspect } from 'utils/web_api.schemas'
import { useWindowLocation } from 'utils/windowLocation'

import { type MetadataConfiguration } from '../types'
import { resolveNextStepPath } from '../utils'
import CreateOrUpdateProspect, { type CreateOrUpdateProspectProps } from './CreateOrUpdateProspect'

type Props = Omit<CreateOrUpdateProspectProps, 'onSuccess'> & {
  nextStepPath: string,
  metadataConfiguration: MetadataConfiguration
}

export function CreateProspect ({ nextStepPath, ...props }: Props) {
  const { replace } = useWindowLocation()

  const onSuccess = (prospect: QuotingProspect) => {
    const path = resolveNextStepPath(nextStepPath, prospect.id)
    replace(path)
  }

  return (
    <div className='flex justify-center'>
      <CreateOrUpdateProspect {...props} onSuccess={onSuccess} />
    </div>
  )
}

export default (props: Props) => {
  return (
    <CreateProspect {...props} />
  )
}
